import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import LanguageDriverDrawer from "components/drawer/LanguageDriverDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";

const LanguageDriverTable = ({
  languagedriver,
  perpage,
  currentPage,

  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <LanguageDriverDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {languagedriver?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>

            <TableCell className="text-center text-xs">
              {data.lang_driver}
            </TableCell>
            {(hideEdit || hideDelete) && (
              <TableCell>
                <div className="flex justify-center">
                  <EditDeleteButton
                    title={data.name}
                    id={data.id}
                    handleUpdate={handleUpdate}
                    handleModalOpen={handleModalOpen}
                    hideEdit={hideEdit}
                    hideDelete={hideDelete}
                  />
                </div>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default LanguageDriverTable;
